import React from "react";
import { Formik } from "formik";
import { loginSchema } from "../AuthorizationSchemas";
import useLogin from "./useLogin";
import { ILoginRequestDto } from "../../../common/dtos";
import LoginForm from "./LoginForm";
import SiweWrapper from "../../../common/components/SiweWrapper";
import { useTranslation } from "react-i18next";

const initialValues: ILoginRequestDto = {
  email: "",
  password: "",
};

const Login = () => {
  const { t } = useTranslation();
  const { onLogin, onCloseError, error } = useLogin();

  return (
    <SiweWrapper
      title={t("login-title")}
      actionText={t("login-eth")}
      dividerText={t("login-use-email")}
    >
      <Formik
        initialValues={initialValues}
        validationSchema={loginSchema}
        onSubmit={onLogin}
      >
        {({ errors, touched, handleSubmit, isSubmitting }) => (
          <LoginForm
            errors={errors}
            touched={touched}
            error={error}
            onCloseError={onCloseError}
            onSubmit={handleSubmit}
            isSubmitting={isSubmitting}
          />
        )}
      </Formik>
    </SiweWrapper>
  );
};

export default Login;
